import { gql, useQuery } from "@apollo/client";
import {
  AlertOverviewByAlertIdQueryQuery,
  AlertOverviewByAlertIdQueryQueryVariables,
} from "../../../../schemaTypes";

export const alertOverviewByAlertIdQuery = gql`
  query AlertOverviewByAlertIdQuery($alertId: String!) {
    alertOverviewByAlertId(alertId: $alertId) {
      items {
        totalNotificationsSent
        totalNotificationsQueued
        totalClicks
        totalRead
        totalUnread
      }
    }
  }
`;

export function useAlertOverviewByAlertId(alertId: string) {
  const { data, loading, error, refetch } = useQuery<
    AlertOverviewByAlertIdQueryQuery,
    AlertOverviewByAlertIdQueryQueryVariables
  >(
    alertOverviewByAlertIdQuery,
    {
      variables: { alertId },
      skip: !alertId,
      notifyOnNetworkStatusChange: true,
    }
  );

  return {
    items: data?.alertOverviewByAlertId?.items || [],
    loading,
    error,
    refetch,
  };
}
